import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { TabView, TabPanel } from "primereact/tabview";
import { ProgressSpinner } from "primereact/progressspinner";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomBreadCrumbs from "../../common/breadcrumbs";
import MyRewards from "./MyRewards";
import PointsHistory from "./PointsHistory";
import RewardsSummary from "./RewardsSummary";
import {
  rewardsRequest,
  pointsHistoryRequest,
  learningProgramsRequest,
} from "../../../store/slices/selfSlice";
import "./learner-rewards.scss";

const TabHeader = ({ label, count }) => (
  <>
    {label} <span className="lr-count">{count}</span>
  </>
);

export const LearnerRewards = ({
  rewards = [],
  pointsHistory = [],
  learningPrograms = [],
  rewardsRequesting,
  pointsHistoryRequesting,
  learningProgramsRequesting,
  rewardsRequest,
  pointsHistoryRequest,
  learningProgramsRequest,
}) => {
  const navigate = useNavigate();
  const intl = useIntl();
  const [activeIndex, setActiveIndex] = useState(0);
  const [requested, setRequested] = useState(false);

  useEffect(() => {
    rewardsRequest();
    pointsHistoryRequest();
    // The learner's enrolments (as on the dashboard) for "Keep going" and
    // the links from a badge to its program.
    learningProgramsRequest();
    setRequested(true);
  }, [rewardsRequest, pointsHistoryRequest, learningProgramsRequest]);

  const labels = [{ label: "my_rewards" }];
  // Nothing is drawn until all three requests have answered: the summary
  // needs all three, and an empty message must not show before its data.
  const loading =
    !requested || rewardsRequesting || pointsHistoryRequesting || learningProgramsRequesting;

  return (
    <div className="edexlms-page learner-rewards">
      <CustomBreadCrumbs labels={labels} navigate={navigate} />
      <div className="edexlms-page-content">
        <div className="lr-header">
          <h1 className="lr-title">{intl.formatMessage({ id: "my_rewards" })}</h1>
          <p className="lr-lede">
            {intl.formatMessage({ id: "my_rewards_subtitle" })}
          </p>
        </div>
        <div className="edexlms-page-body">
          {loading ? (
            <div className="flex justify-content-center p-4">
              <ProgressSpinner />
            </div>
          ) : (
            <>
              <RewardsSummary
                rewards={rewards}
                pointsHistory={pointsHistory}
                learningPrograms={learningPrograms}
              />
              <TabView
                activeIndex={activeIndex}
                onTabChange={(e) => setActiveIndex(e.index)}
                className="lr-tabs"
              >
                <TabPanel
                  header={
                    <TabHeader
                      label={intl.formatMessage({ id: "my_rewards_tab_badges" })}
                      count={intl.formatNumber(rewards.length)}
                    />
                  }
                >
                  <MyRewards
                    rewards={rewards}
                    learningPrograms={learningPrograms}
                    requesting={rewardsRequesting}
                  />
                </TabPanel>
                <TabPanel
                  header={
                    <TabHeader
                      label={intl.formatMessage({
                        id: "my_rewards_tab_points_history",
                      })}
                      count={intl.formatNumber(pointsHistory.length)}
                    />
                  }
                >
                  <PointsHistory
                    pointsHistory={pointsHistory}
                    requesting={pointsHistoryRequesting}
                  />
                </TabPanel>
              </TabView>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const NONE = [];

const mapStateToProps = (state) => ({
  rewards: state.self.rewards || NONE,
  pointsHistory: state.self.pointsHistory || NONE,
  learningPrograms: state.self.learningPrograms || NONE,
  rewardsRequesting: state.self.rewardsRequesting,
  pointsHistoryRequesting: state.self.pointsHistoryRequesting,
  learningProgramsRequesting: state.self.learningProgramsRequesting,
});

const mapDispatchToProps = (dispatch) => ({
  rewardsRequest: () => dispatch(rewardsRequest()),
  pointsHistoryRequest: () => dispatch(pointsHistoryRequest()),
  learningProgramsRequest: () => dispatch(learningProgramsRequest()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LearnerRewards);
